// import React from "react";
// import BlogImage from "../../components/Blog Details/BlogImage";
// import BodyContent from "../../components/Blog Details/BodyContent";
// import PageHeader from "../../components/common/PageHeader";
// import BlogImageHeading from "../../components/Blog Details/BlogImageHeading";
// import LatestServiceOffer from "../../components/common/LatestServiceOffer";

// const BlogDetails = () => {
//   return (
//     <div>
//       <PageHeader title="Blog Details" />
//       <BlogImage />
//       <BlogImageHeading />
//       <BodyContent />
//       <LatestServiceOffer />
//     </div>
//   );
// };

// export default BlogDetails;

import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import BlogImage from "../../components/Blog Details/BlogImage";
import BodyContent from "../../components/Blog Details/BodyContent";
import PageHeader from "../../components/common/PageHeader";
import BlogImageHeading from "../../components/Blog Details/BlogImageHeading";
import LatestServiceOffer from "../../components/common/LatestServiceOffer";

const BlogDetails = () => {
  const { id } = useParams();
  const [blogData, setBlogData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlogData = async () => {
      try {
        setLoading(true);
        const config = {
          method: "get",
          maxBodyLength: Infinity,
          url: `${process.env.REACT_APP_API_URL}/blogs/get-blog-by-id/${id}`,
          headers: {},
        };

        const response = await axios.request(config);
        setBlogData(response.data);
      } catch (error) {
        console.error("Error fetching blog data:", error);
        setError("Failed to load blog data");
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchBlogData();
    }
  }, [id]);

  if (loading) {
    return (
      <div>
        <PageHeader title="Blog Details" />
        <div className="animate-pulse max-h-80 bg-gray-300 w-full"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <PageHeader title="Blog Details" />
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Error</h2>
            <p className="text-gray-600">{error}</p>
          </div>
        </div>
      </div>
    );
  }

  if (!blogData) {
    return (
      <div>
        <PageHeader title="Blog Details" />
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Not Found</h2>
            <p className="text-gray-600">Blog post not found</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <PageHeader title="Blog Details" />
      <BlogImage blogData={blogData} />
      <BlogImageHeading blogData={blogData} />
      <BodyContent blogData={blogData} />
      <LatestServiceOffer />
    </div>
  );
};

export default BlogDetails;
